import { isFaceRecognitionUnsupportedOnScreen } from '../../../panels/asset_face_recognition/utils';
import type { AppState } from '../../../store/types';

export const getInConfirmationMode = (state: AppState) =>
  state.panelsState.assetFaceRecognition.inConfirmationMode &&
  !isFaceRecognitionUnsupportedOnScreen(state.displayReducer.breakpoint);
